/**
 * Convert a DOM HTMLElement to `MentionAttrs` - ProseMirror 'mention' node attributes.
 */
export function getMentionAttrsFromDOM(dom) {
    const id = dom.getAttribute("mention-id");
    const title = dom.getAttribute("title");
    const prefix = dom.textContent.substr(0, 1);
    const applicationId = dom.getAttribute("mention-application-id");
    const applicationSlug = dom.getAttribute("mention-application-slug");
    const applicationName = dom.getAttribute("mention-application-name");
    if (!id ||
        !applicationId ||
        !applicationSlug ||
        !applicationName ||
        !title ||
        !prefix) {
        return false;
    }
    return {
        id,
        title,
        prefix,
        application: {
            id: applicationId,
            name: applicationName,
            slug: applicationSlug,
        },
    };
}
